module.exports = __webpack_public_path__ + "img/logo.e294686f.png";